module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAG0lEQVR4nGNgwA3+IzNwYYIK4IowjCVoLwwAAHp/Ee+KEoBJAAAAAElFTkSuQmCC"